import { render, staticRenderFns } from "./IntegerField.vue?vue&type=template&id=8a64ec4c&scoped=true&"
import script from "./IntegerField.vue?vue&type=script&lang=js&"
export * from "./IntegerField.vue?vue&type=script&lang=js&"
import style0 from "./IntegerField.vue?vue&type=style&index=0&id=8a64ec4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a64ec4c",
  null
  
)

export default component.exports